
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Container,
  Form,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getSettings, updateSetting } from "../../store/settings/actions";
import FormEditors from "../Forms/FormEditors";


const TermsAndConditions = (props) => {

  const dispatch = useDispatch()
  const settings = useSelector(state => state.settings.settings)
  const [terms_and_conditions_ar, setTermsAndConditionsAr] = useState("")
  const [terms_and_conditions_en, setTermsAndConditionsEn] = useState("")
  const [terms_and_conditions_fr, setTermsAndConditionsFr] = useState("")
  useEffect(() => {
    dispatch(getSettings())
  }, [dispatch])
  useEffect(() => {
    setTermsAndConditionsAr(settings.terms_and_conditions_ar)
    setTermsAndConditionsEn(settings.terms_and_conditions_en)
    setTermsAndConditionsFr(settings.terms_and_conditions_fr)
  }, [settings])
  const handleSubmit = () => {
    dispatch(
      updateSetting({
        id: settings.id ?? 1,
        terms_and_conditions_ar,
        terms_and_conditions_en,
        terms_and_conditions_fr,
      })
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Terms and Conditions" breadcrumbItem="" />
          <Row>
            <Col xl="6"></Col>

            <Col xl="6"></Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <h4>Terms and conditions</h4>
                  <p className="card-title-desc">
                    {/* Parsley is a availity reactstrap validation. It helps you
                    provide your users with feedback on their form submission
                    before sending it to your server. */}
                  </p>

                  {/* <Form
                    onSubmit={e => {
                      e.preventDefault()
                      return false
                    }}
                    className="custom-validation"
                  > */}
                  <Label>
                    <h4 className="card-title">English</h4>
                  </Label>

                  <FormEditors
                    value={terms_and_conditions_en}
                    onChange={setTermsAndConditionsEn}
                  />
                  <Label>
                    <h4 className="card-title">French</h4>
                  </Label>
                  <FormEditors
                    value={terms_and_conditions_fr}
                    onChange={setTermsAndConditionsFr}
                  />

                  <Label>
                    <h4 className="card-title">Arabic</h4>
                  </Label>
                  <FormEditors
                    value={terms_and_conditions_ar}
                    onChange={setTermsAndConditionsAr}
                  />

                  <div className="d-flex flex-wrap gap-2">
                    <Button
                      type="button"
                      color="primary"
                      className=""
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>{" "}
                    <Button type="reset" color="secondary" className="">
                      Cancel
                    </Button>
                  </div>
                  {/* </Form> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
};

export default TermsAndConditions
